import { createSlice } from '@reduxjs/toolkit'

const ITEM_INFO_MODAL_INITIAL_CONTENT = {
  erpItemNumber: '',
  title: '',
  titleLong: '',
  descriptionShort: '',
  articleUrl: '',
  attributes: [],
  imgSrc: '',
}

const initialState = {
  shouldRenderFaq: false,
  shouldRenderUserGuide: false,
  isAddToCartPromptModalOpen: false,
  isAddToCartConfirmedModalOpen: false,
  isAddToCartAdditionalPromptModalOpen: false,
  isAddToCartErrorModalOpen: false,
  isAddToCartUnavailableModalOpen: false,
  isArticleSubstitutionsModalOpen: false,
  isBackPromptModalOpen: false,
  isEditItemPanelActive: false,
  isFailedToLoadProjectModalOpen: false,
  isFaqModalOpen: false,
  isGable14UnavailableModalOpen: false,
  isItemInfoModalOpen: false,
  isMessageModalOpen: false,
  isMobileMenuOpen: false,
  isSaveProjectToMailModalOpen: false,
  isSaveProjectOfferModalOpen: false,
  isSummaryPreviewExpanded: false,
  isSummaryPanelVisible: false,
  isUserGuideModalOpen: false,
  itemInfoModal: {
    content: ITEM_INFO_MODAL_INITIAL_CONTENT,
    isOpen: false,
  },
  messageModalContent: {
    dangerouslySetMessage: '',
  },
  selectedToolbarTabIndex: 0,
  selectedToolbarRoofSubTab: 0,
  selectedToolbarLoftFloorSubTab: 0,
  selectedToolbarDoorSubTab: 0,
  selectedToolbarGarageSubTab: 0,
  toolbarOffsetHeight: null, // TODO: not used?
  loftSelected: false,
  loftUnavailableModalOpen: false,
  viewInside: false,
  isMobileDrawerOpen: false,
  isDelayedDeliverySelected: false,
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    handleItemInfoModalClose(state) {
      state.itemInfoModal.content = ITEM_INFO_MODAL_INITIAL_CONTENT
      state.itemInfoModal.isOpen = false
    },
    handleItemInfoModalOpen(state, action) {
      const { erpItemNumber, title, titleLong, descriptionShort, articleUrl, attributes, imgSrc } = action.payload
      state.itemInfoModal.content.erpItemNumber = erpItemNumber
      state.itemInfoModal.content.title = title
      state.itemInfoModal.content.titleLong = titleLong
      state.itemInfoModal.content.descriptionShort = descriptionShort
      state.itemInfoModal.content.articleUrl = articleUrl
      state.itemInfoModal.content.attributes = attributes.filter(
        (attribute: any) => attribute.Title.trim().toLowerCase() !== 'garanti' // behöver språkhanteras framöver
      )
      state.itemInfoModal.content.imgSrc = imgSrc
      state.itemInfoModal.isOpen = true
    },
    setShouldRenderFaq(state, action) {
      state.shouldRenderFaq = action.payload
    },
    setShouldRenderUserGuide(state, action) {
      state.shouldRenderUserGuide = action.payload
    },
    setIsAddToCartPromptModalOpen(state, action) {
      state.isAddToCartPromptModalOpen = action.payload
    },
    setIsAddToCartConfirmedModalOpen(state, action) {
      state.isAddToCartConfirmedModalOpen = action.payload
    },
    setIsAddToCartAdditionalPromptModalOpen(state, action) {
      state.isAddToCartAdditionalPromptModalOpen = action.payload
    },
    setIsAddToCartErrorModalOpen(state, action) {
      state.isAddToCartErrorModalOpen = action.payload
    },
    setIsAddToCartUnavailableModalOpen(state, action) {
      state.isAddToCartUnavailableModalOpen = action.payload
    },
    setIsBackPromptModalOpen(state, action) {
      state.isBackPromptModalOpen = action.payload
    },
    setIsArticleSubstitutionsModalOpen(state, action) {
      state.isArticleSubstitutionsModalOpen = action.payload
    },
    setIsEditItemPanelActive(state, action) {
      state.isEditItemPanelActive = action.payload
      state.isMobileDrawerOpen = action.payload
      if (action.payload) {
        state.isSummaryPanelVisible = false
      }
    },
    setIsFailedToLoadProjectModalOpen(state, action) {
      state.isFailedToLoadProjectModalOpen = action.payload
    },
    setIsFaqModalOpen(state, action) {
      state.isFaqModalOpen = action.payload
    },
    setGable14UnavailableModalOpen(state, action) {
      state.isGable14UnavailableModalOpen = action.payload
    },
    setIsItemInfoModalOpen(state, action) {
      state.isItemInfoModalOpen = action.payload
    },
    setIsMessageModalOpen(state, action) {
      state.isMessageModalOpen = action.payload
    },
    setIsMobileMenuOpen(state, action) {
      state.isMobileMenuOpen = action.payload
    },
    setIsSaveProjectToMailModalOpen(state, action) {
      state.isSaveProjectToMailModalOpen = action.payload
    },
    setIsSaveProjectOfferModalOpen(state, action) {
      state.isSaveProjectOfferModalOpen = action.payload
    },
    setIsSummaryPanelVisible(state, action) {
      state.isSummaryPanelVisible = action.payload
      if (action.payload) {
        state.isEditItemPanelActive = false
        state.isMobileDrawerOpen = false
      }
    },
    setIsSummaryPreviewExpanded(state, action) {
      state.isSummaryPreviewExpanded = action.payload
    },
    setIsUserGuideModalOpen(state, action) {
      state.isUserGuideModalOpen = action.payload
    },
    setMessageModalContent(state, action) {
      const { dangerouslySetMessage } = action.payload
      state.messageModalContent.dangerouslySetMessage = dangerouslySetMessage
    },
    setSelectedToolbarTabIndex(state, action) {
      state.selectedToolbarTabIndex = action.payload
    },
    setSelectedToolbarRoofSubTab(state, action) {
      state.selectedToolbarRoofSubTab = action.payload
    },
    setSelectedToolbarLoftFloorSubTab(state, action) {
      state.selectedToolbarLoftFloorSubTab = action.payload
    },
    setSelectedToolbarGarageSubTab(state, action) {
      state.selectedToolbarGarageSubTab = action.payload
    },
    setSelectedToolbarDoorSubTab(state, action) {
      state.selectedToolbarDoorSubTab = action.payload
    },
    setToolbarOffsetHeight(state, action) {
      state.toolbarOffsetHeight = action.payload
    },
    setLoftSelected(state, action) {
      state.loftSelected = action.payload
    },
    setloftUnavailableModalOpenModalOpen(state, action) {
      state.loftUnavailableModalOpen = action.payload
    },
    setViewInside(state, action) {
      state.viewInside = action.payload
    },
    setIsMobileDrawerOpen(state, action) {
      state.isMobileDrawerOpen = action.payload
    },
    setIsDelayedDeliverySelected(state, action) {
      state.isDelayedDeliverySelected = action.payload
    },
  },
})

export const {
  handleItemInfoModalClose,
  handleItemInfoModalOpen,
  setShouldRenderFaq,
  setShouldRenderUserGuide,
  setIsAddToCartPromptModalOpen,
  setIsAddToCartConfirmedModalOpen,
  setIsAddToCartAdditionalPromptModalOpen,
  setIsAddToCartErrorModalOpen,
  setIsAddToCartUnavailableModalOpen,
  setIsBackPromptModalOpen,
  setIsArticleSubstitutionsModalOpen,
  setIsEditItemPanelActive,
  setIsFaqModalOpen,
  setIsFailedToLoadProjectModalOpen,
  setGable14UnavailableModalOpen,
  setIsItemInfoModalOpen,
  setIsMessageModalOpen,
  setIsMobileMenuOpen,
  setIsSaveProjectToMailModalOpen,
  setIsSaveProjectOfferModalOpen,
  setIsSummaryPanelVisible,
  setIsSummaryPreviewExpanded,
  setIsUserGuideModalOpen,
  setMessageModalContent,
  setSelectedToolbarTabIndex,
  setSelectedToolbarRoofSubTab,
  setSelectedToolbarLoftFloorSubTab,
  setSelectedToolbarDoorSubTab,
  setSelectedToolbarGarageSubTab,
  setToolbarOffsetHeight,
  setLoftSelected,
  setloftUnavailableModalOpenModalOpen,
  setViewInside,
  setIsMobileDrawerOpen,
  setIsDelayedDeliverySelected,
} = uiSlice.actions

export default uiSlice.reducer
